'use client'

import React from 'react'
import { useModels } from '../hooks/useModels'

/**
 * ModelProvider component that initializes models when the application starts.
 * This ensures models are loaded once, regardless of which components are rendered.
 */
export const ModelProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  // Use the models hook with autoFetch enabled
  useModels({ autoFetch: true })

  return <>{children}</>
}
